// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"54cc71ee","221":"96928c97","300":"c28bc5ff","311":"3fe283dc","366":"e9cc5493","441":"9bc93e9c","532":"de0ad2aa","604":"ca225554","633":"6cfd21f7","716":"e33ccc7d","839":"95d5e9aa"}[chunkId] + ".chunk.js";
};